import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Input,
  Form,
  Label,
  Button,
} from "reactstrap";
import { getProvince, getRegency, postRegister } from "../../service/services";
import swal from "sweetalert";
import { FaCheck } from "react-icons/fa";

const Hero = () => {
  const [inputName, setInputName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedRegency, setSelectedRegency] = useState("");
  const [province, setProvince] = useState([]);
  const [regency, setRegency] = useState([]);
  const [error, setError] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);

  const inputBorder = { border: "1px solid #ca0b0b" };

  /* ================== UTIL ================== */
  const isValidEmail = (email) => {
    if (!email) return false;
    const lastAtPos = email.lastIndexOf("@");
    const lastDotPos = email.lastIndexOf(".");
    return (
      lastAtPos < lastDotPos &&
      lastAtPos > 0 &&
      email.indexOf("@@") === -1 &&
      lastDotPos > 2 &&
      email.length - lastDotPos > 2
    );
  };

  /* ================== FETCH DATA ================== */
  useEffect(() => {
    getProvince().then((data) => {
      if (data) setProvince(data);
    });
  }, []);

  useEffect(() => {
    if (selectedProvince) {
      getRegency(selectedProvince).then((data) => {
        if (data) setRegency(data);
      });
    }
  }, [selectedProvince]);

  /* ================== VALIDATION ================== */
  const handleValidation = () => {
    let errors = {};
    let isValid = true;

    if (!inputName) {
      isValid = false;
      errors.inputName = "Nama wajib diisi";
    }

    if (!phone) {
      isValid = false;
      errors.phone = "No telepon wajib diisi";
    }

    if (!email) {
      isValid = false;
      errors.email = "Email wajib diisi";
    } else if (!isValidEmail(email)) {
      isValid = false;
      errors.email = "Email tidak valid";
    }

    if (!selectedProvince || selectedProvince === "0") {
      isValid = false;
      errors.selectedProvince = "Provinsi wajib diisi";
    }

    if (!selectedRegency || selectedRegency === "0") {
      isValid = false;
      errors.selectedRegency = "Kabupaten / Kota wajib diisi";
    }

    setError(errors);
    return isValid;
  };

  /* ================== SUBMIT ================== */
  const sendData = () => {
    setBtnDisabled(true);

    postRegister(
      inputName,
      phone,
      email,
      selectedProvince,
      selectedRegency
    ).then((reply) => {
      if (reply?.id) {
        swal("Selamat", "Pendaftaran berhasil", "success").then(() => {
          window.location.reload();
        });
      } else {
        swal("Gagal", "Pendaftaran gagal, silakan coba lagi", "error");
        setBtnDisabled(false);
      }
    });
  };

  const registrationSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      sendData();
    }
  };

  /* ================== RENDER ================== */
  return (
    <section className="section bg-home d-flex align-items-center" id="beranda">
      <Container>
        <Row className="flex-column flex-md-row align-items-center">
          <Col xs='12' lg='7'>
            <div className="box-wrapper">
              <h1 className="mb-2"><b>Upgrade Masa Depanmu di Melbourne!</b></h1>
              <p className="mb-3">Belajar Skill yang Dicari Dunia Kerja di Melbourne Polytechnic</p>
              <p>
                Kuliah di institusi vokasi & degree ternama dengan 
                sistem praktik langsung, fasilitas kelas dunia, 
                komunitas internasional, dan kesempatan 
                kerja sambil kuliah.           
              </p>
              <div className="mt-3">
                <p><FaCheck className="me-3" />Lulus siap kerja</p>
                <p><FaCheck className="me-3" />Peluang karier global</p>
                <p><FaCheck className="me-3" />Pengalaman hidup di Australia</p>
              </div>
            </div>
          </Col>

          <Col xs='12' lg='5' className='d-flex justify-content-center'>
            <div className="home-registration-form bg-white p-3">
              <h6 className="text-center fw-bold mb-3">Form Pendaftaran</h6>

              <Form onSubmit={registrationSubmit}>
                {/* <Label>Nama Lengkap</Label> */}
                <div className="mb-3">
                  <Input
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)}
                    style={error.inputName ? inputBorder : {}}
                    placeholder='Nama Lengkap'
                  />
                  <small className="text-danger">{error.inputName}</small>
                </div>

                {/* <Label>Email</Label> */}
                <div className="mb-3">
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={error.email ? inputBorder : {}}
                    placeholder='Email'
                  />
                  <small className="text-danger">{error.email}</small>
                </div>

                {/* <Label>No. Whatsapp</Label> */}
                <div className="mb-3">
                  <Input
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    style={error.phone ? inputBorder : {}}
                    placeholder='No. Whatsapp'
                  />
                  <small className="text-danger">{error.phone}</small>
                </div>

                {/* <Label>Provinsi</Label> */}
                <div className="mb-3">
                  <Input
                    type="select"
                    value={selectedProvince}
                    onChange={(e) => {
                      setSelectedProvince(e.target.value);
                      setSelectedRegency("");
                      setRegency([]);
                    }}
                    style={error.selectedProvince ? inputBorder : {}}
                    className='form-control'
                  >
                    <option value="0">Pilih Provinsi</option>
                    {province.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.province_name}
                      </option>
                    ))}
                  </Input>
                  <small className="text-danger">
                    {error.selectedProvince}
                  </small>                  
                </div>

                {/* <Label>Kabupaten / Kota</Label> */}
                <div className="mb-3">
                  <Input
                    type="select"
                    value={selectedRegency}
                    onChange={(e) => setSelectedRegency(e.target.value)}
                    style={error.selectedRegency ? inputBorder : {}}
                    className='form-control'
                  >
                    <option value="0">Pilih Kabupaten/Kota</option>
                    {regency.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.kabupaten_name}
                      </option>
                    ))}
                  </Input>
                  <small className="text-danger">
                    {error.selectedRegency}
                  </small>
                </div>

                <Button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={btnDisabled}
                >
                  Daftar Sekarang
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;